import { InjectionToken } from '@angular/core';
import { LanguageSwitcherConfig } from '../interface';

export const LANGUAGE_SWITCHER_CONFIG = new InjectionToken<LanguageSwitcherConfig>('LANGUAGE_SWITCHER_CONFIG');
